import "./App.css";
import Header from "components/Header";
import GameLogic from "components/GameLogic";

function App() {
  return (
    <div className="App">
      <Header />
      <GameLogic />
    </div>
  );
}

export default App;
